import styled from 'styled-components'

import { useAppThemeBranding } from '../hooks/useAppTheme'

interface AppLogoProps {
  variant?: 'full' | 'only';
  width?: number;
  height?: number;
  alt?: string;
  className?: string;
}

export const AppLogo: React.FC<AppLogoProps> = ({ 
  variant = 'full', 
  width, 
  height, 
  alt,
  className 
}) => {
  const branding = useAppThemeBranding()
  
  const logoSrc = variant === 'only' && branding.logoOnly 
    ? branding.logoOnly 
    : branding.logo
  
  const logoAlt = alt || branding.appName

  return (
    <StyledLogo
      src={logoSrc}
      alt={logoAlt}
      width={width}
      height={height}
      className={className}
    />
  )
}

const StyledLogo = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
` 